export * from './floatingPlaceholder.styled';
